import { IBankWatchDashboardSummary } from '@/domain/bankwatch'

export const isFetchingSummary = (state: any, isFetchingSummary: boolean) => {
    state.isFetchingSummary = isFetchingSummary;
}

export const summary = (state: any, summary: IBankWatchDashboardSummary | null) => {
    state.summary = summary;
}

export const summaryError = (state: any, summaryError: string) => {
    state.summaryError = summaryError;
}
